import { render, staticRenderFns } from "./Etsy.vue?vue&type=template&id=22590e8d&scoped=true"
import script from "./Etsy.vue?vue&type=script&lang=js"
export * from "./Etsy.vue?vue&type=script&lang=js"
import style0 from "./Etsy.vue?vue&type=style&index=0&id=22590e8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22590e8d",
  null
  
)

export default component.exports